import React from "react";
import { Modal } from "react-bootstrap";
import logout from "../../images/dealPostSuccess.svg";
import { useHistory } from "react-router-dom";

const ReferralSuccessModal = (props) => {
  const history = useHistory();

  const onClickHandler = () => {
    props.setIsPostSuccess(false);
    history.push("/dashboard");
  };

  return (
    <Modal
      className="logoutpop"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <h4> {props.message} </h4>
        <div className="logout-image">
          <img src={logout} alt="logout image" />
        </div>
        {!props.isContact ? (
          <div className="logoutpop-body">
            <div className="logout-popup">
              <button onClick={onClickHandler}>Go to Dashboard</button>
            </div>
          </div>
        ) : (
          ""
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ReferralSuccessModal;
